
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props} className="bg-gray-900 border-gray-700 text-white max-w-[90vw] md:max-w-[420px]">
            <div className="grid gap-1">
              {title && <ToastTitle className="text-[#de0046] font-bold">{title}</ToastTitle>}
              {description && (
                <ToastDescription className="text-gray-300 whitespace-pre-wrap break-words overflow-auto max-h-[70vh]">{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
